import { Cloud, ExternalLink, ListChecks, MonitorCog, Settings, StickyNote, Table2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { getConfig } from "../api/settings";
import { cn } from "../lib/utils";

export type PageKey = "accounts" | "profiles" | "tasks" | "notes" | "settings";

const nav = [
  { key: "accounts", label: "Discord 账号", icon: Table2 },
  { key: "profiles", label: "浏览器环境", icon: MonitorCog },
  { key: "tasks", label: "任务队列", icon: ListChecks },
  { key: "notes", label: "便签", icon: StickyNote },
  { key: "settings", label: "运行配置", icon: Settings }
] as const;

const DEFAULT_CLOUD_BROWSER_URL = "https://browser.zhongwenmj.com";

export function AppShell({ page, onPageChange, children }: { page: PageKey; onPageChange: (page: PageKey) => void; children: React.ReactNode }) {
  const config = useQuery({ queryKey: ["config"], queryFn: getConfig });
  const configuredBrowserUrl = config.data?.config?.cloud_browser_url;
  const cloudBrowserUrl = typeof configuredBrowserUrl === "string" && configuredBrowserUrl.trim() ? configuredBrowserUrl.trim() : DEFAULT_CLOUD_BROWSER_URL;
  return (
    <div className="min-h-screen bg-slate-100 text-slate-950">
      <header className="flex h-12 items-center border-b border-slate-200 bg-white px-3 sm:px-4">
        <div className="mr-3 flex shrink-0 items-center gap-2 font-semibold sm:mr-5">
          <span className="grid h-7 w-7 place-items-center rounded bg-slate-900 text-xs text-white">MJ</span>
          账号控制台
        </div>
        <nav className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto">
          {nav.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                className={cn(
                  "flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-3 text-xs text-slate-600 hover:bg-slate-100",
                  page === item.key && "bg-slate-900 text-white hover:bg-slate-900"
                )}
                onClick={() => onPageChange(item.key)}
              >
                <Icon size={14} />
                {item.label}
              </button>
            );
          })}
        </nav>
        <a
          className="ml-2 flex h-8 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-slate-200 bg-white px-3 text-xs text-slate-700 shadow-sm hover:bg-slate-50"
          href={cloudBrowserUrl}
          target="_blank"
          rel="noreferrer"
        >
          <Cloud size={14} />
          云端浏览器
          <ExternalLink size={12} />
        </a>
      </header>
      <main className="h-[calc(100vh-3rem)] overflow-hidden">{children}</main>
    </div>
  );
}
